(function () {
  'use strict';

  if (window.__aeExitPopupBoot) return;
  window.__aeExitPopupBoot = true;

  const root = document.querySelector('[data-ae-exit-popup]');
  if (!root) return;

  const cfg = {
    currentSuffix: (root.dataset.currentSuffix || '').toLowerCase(),
    desktopOn: root.dataset.desktopTrigger === 'true',
    mobileOn: root.dataset.mobileTrigger === 'true',
    cooldownDays: parseInt(root.dataset.cooldownDays, 10) || 7
  };

  const STORAGE_KEY = 'ae_exit_popup_v1';
  const getState = () => {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || {}; } catch (e) { return {}; }
  };
  const setState = (s) => {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(s)); } catch (e) {}
  };
const currentHandle = () => {
    const m = location.pathname.match(/^\/pages\/([^/?#]+)/i);
    return m ? m[1].toLowerCase() : null;
  };
  const parseList = (raw) =>
    raw.split(/[\n,]+/).map((s) => s.trim().toLowerCase()).filter(Boolean);

  const handle = currentHandle();
  const suffix = cfg.currentSuffix;

  const blockMatches = (panel) => {
    const handleList = parseList(panel.dataset.pageHandles || '');
    const suffixList = parseList(panel.dataset.templateSuffixes || '');

    if (suffixList.length && suffix && suffixList.indexOf(suffix) !== -1) return true;
    if (handleList.length && handle && handleList.indexOf(handle) !== -1) return true;
    return false;
  };

  const panels = Array.from(root.querySelectorAll('[data-ae-exit-block]'));
  const panel = panels.find(blockMatches);

  if (!panel) return;
  panels.forEach((p) => { if (p !== panel) p.remove(); });
const isWelcomeSubscribed = () => {
    try {
      const welcome = JSON.parse(localStorage.getItem('ae_popup_signup_v1') || '{}');
      return !!welcome.subscribed;
    } catch (e) { return false; }
  };

  const shouldShow = () => {
    if (isWelcomeSubscribed()) return false;
    const s = getState();
    if (s.revealed) return false;
    if (s.dismissedAt) {
      const ms = cfg.cooldownDays * 24 * 60 * 60 * 1000;
      if (Date.now() - s.dismissedAt < ms) return false;
    }
    return true;
  };

  if (!shouldShow()) return;
const isAnySidebarOpen = () => document.querySelector('.sidebar--opened') !== null;
let isOpen = false;
  const open = () => {
    if (isOpen) return;
    if (isAnySidebarOpen()) return;
    isOpen = true;
    panel.removeAttribute('hidden');
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.body.classList.add('ae-exit-popup-open');
    panel.querySelector('[data-ae-exit-claim]')?.focus({ preventScroll: true });
  };
  const close = (action) => {
    if (!isOpen) return;
    isOpen = false;
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('ae-exit-popup-open');
    if (action === 'dismiss') {
      const s = getState();
      s.dismissedAt = Date.now();
      setState(s);
    } else if (action === 'revealed') {
      const s = getState();
      s.revealed = true;
      s.revealedAt = Date.now();
      setState(s);
    }
  };

  const showStep = (name) => {
    panel.querySelectorAll('[data-ae-exit-step]').forEach((el) => {
      el.classList.toggle('is-active', el.dataset.aeExitStep === name);
    });
  };
panel.querySelector('[data-ae-exit-claim]')?.addEventListener('click', () => {
    showStep('confirm');
    panel.querySelector('[data-ae-exit-reveal]')?.focus({ preventScroll: true });
  });
panel.querySelector('[data-ae-exit-reveal]')?.addEventListener('click', () => {
    showStep('reveal');
    const s = getState();
    s.revealed = true;
    s.revealedAt = Date.now();
    setState(s);
    panel.querySelector('[data-ae-exit-copy]')?.focus({ preventScroll: true });
  });
const copyBtn = panel.querySelector('[data-ae-exit-copy]');
  const codeEl = panel.querySelector('[data-ae-exit-code]');

  const fallbackCopy = (text) => {
    const ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    try { document.execCommand('copy'); } catch (e) {}
    document.body.removeChild(ta);
  };

  copyBtn?.addEventListener('click', async () => {
    const code = (codeEl?.textContent || '').trim();
    if (!code) return;
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(code);
      } else {
        fallbackCopy(code);
      }
    } catch (e) {
      fallbackCopy(code);
    }
    const copiedLabel = copyBtn.dataset.copiedLabel || 'Copied!';
    const originalLabel = copyBtn.dataset.copyLabel || 'Copy code';
    copyBtn.textContent = copiedLabel;
    copyBtn.classList.add('is-copied');
    setTimeout(() => {
      copyBtn.textContent = originalLabel;
      copyBtn.classList.remove('is-copied');
    }, 2200);
  });
panel.querySelectorAll('[data-ae-exit-close]').forEach((el) => {
    el.addEventListener('click', () => close('dismiss'));
  });
  root.querySelectorAll('[data-ae-exit-close]').forEach((el) => {
    el.addEventListener('click', () => close('dismiss'));
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && isOpen) close('dismiss');
  });
const cartDrawer = document.getElementById('site-cart-sidebar');
  if (cartDrawer) {
    const sidebarObserver = new MutationObserver(() => {
      if (isOpen && isAnySidebarOpen()) close('dismiss');
    });
    sidebarObserver.observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });
    window.addEventListener('pagehide', () => sidebarObserver.disconnect(), { once: true });
  }
if (cfg.desktopOn && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    const onLeave = (e) => {
      if (e.clientY <= 0) {
        document.removeEventListener('mouseleave', onLeave);
        open();
      }
    };
    document.addEventListener('mouseleave', onLeave);
  }
if (cfg.mobileOn) {
    const isTouch = window.matchMedia('(hover: none), (pointer: coarse)').matches;
let allowExit = false;
    const installSentinel = () => {
      try { history.pushState({ ae_exit_sentinel: true }, '', location.href); } catch (e) {}
    };
    installSentinel();
    window.addEventListener('popstate', () => {
      if (allowExit) return;
      installSentinel();
      open();
      allowExit = true;
    });

    if (isTouch) {
const onScroll = () => {
        const y = window.scrollY;
        const docH = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
        const pct = docH > 0 ? y / docH : 0;
        if (pct >= 0.4 && !isOpen) {
          window.removeEventListener('scroll', onScroll);
          open();
        }
      };
      window.addEventListener('scroll', onScroll, { passive: true });
let idleTimer;
      const IDLE_MS = 30000;
      const resetIdle = () => {
        clearTimeout(idleTimer);
        idleTimer = setTimeout(() => { if (!isOpen) open(); }, IDLE_MS);
      };
      ['scroll', 'touchstart', 'touchmove', 'click', 'keydown'].forEach((evt) => {
        window.addEventListener(evt, resetIdle, { passive: true });
      });
      resetIdle();
let wasHidden = false;
      let hiddenAt = 0;
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'hidden') {
          wasHidden = true;
          hiddenAt = Date.now();
        } else if (document.visibilityState === 'visible' && wasHidden) {
          if (Date.now() - hiddenAt > 4000 && !isOpen) open();
          wasHidden = false;
        }
      });
    }
  }
})();
